import {FormGroup, NgForm} from '@angular/forms';
import {throwError} from 'rxjs';

export function Throttle(delay: number = 1000): MethodDecorator {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        let inThrottle;
        const original = descriptor.value;
        descriptor.value = function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                original.apply(context, args);
                inThrottle = true;
                setTimeout(() => {
                    inThrottle = false;
                }, delay);
            }
        };

        return descriptor;
    };
}

export function Debounce(delay: number = 1000): MethodDecorator {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        let timeout = null;
        const original = descriptor.value;

        descriptor.value = function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => original.apply(this, args), delay);
        };

        return descriptor;
    };
}


export function CheckFormValid(form?: FormGroup): MethodDecorator {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        const original = descriptor.value;
        descriptor.value = function(...args) {
            const f = form ? form : args[0];
            let controls;
            if (f instanceof NgForm) {
                if (f.form.invalid) {
                    controls = f.form.controls;
                    for (const c in controls) {
                        if (c) {
                            controls[c].markAsTouched();
                            controls[c].markAsDirty();
                        }
                    }
                } else {
                    original.apply(this, args);
                }
            } else if (f instanceof FormGroup) {
                if (f.invalid) {
                    controls = f.controls;
                    for (const c in controls) {
                        if (c) {
                            controls[c].markAsTouched();
                            controls[c].markAsDirty();
                        }
                    }
                } else {
                    original.apply(this, args);
                }
            } else {
                console.error('Function need get NgForm or Decorator need get FormGroup');
                throwError(true);
            }

        };
        return descriptor;
    };
}
